import {ComputationResult} from './../computation-result';
import {Computation} from './../computation';
import {GroupingResult} from './../../grouping/grouping-result';
import {Grouping} from './../../grouping/grouping';
import {_AvailableResult} from './../available-result';

/**
 * Generated from com.dataiku.dip.eda.compute.computations.multivariate.PCA
 */
export interface PCA extends Computation._MultivariateComputation {
    projectionDim: number;
    projectionGrouping: Grouping;

    // PolyJson type
    type: 'pca';
}

export function isPCA(toTest: Computation): toTest is PCA { return 'pca' === toTest.type; }

export namespace PCA {
    /**
     * Generated from com.dataiku.dip.eda.compute.computations.multivariate.PCA$PCAResult
     */
    export interface PCAResult extends _AvailableResult {
        eigenvalues: number[];
        eigenvectors: number[][];
        groups: GroupingResult;
        projections: number[][][];

        // PolyJson type
        type: 'pca';
    }

    export function isPCAResult(toTest: ComputationResult): toTest is PCAResult { return 'pca' === toTest.type; }
}